import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

export class PlatformReferral extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  modelType;

  /**
   * @var {number}
   */
  modelId;

  /**
   * @var {number}
   */
  referralId;

  /**
   * @relationship
   * @var {User}
   */
  user;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.referralId = model.referralId;
  }

  /**
   * @returns {string}
   */
  getModelName() {
    return ModelType.PLATFORM_REFERRAL;
  }
}
